// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from '../../../../common/Links';
import ButtonLink from '../../../../common/Buttons/ButtonLink';
import SnippetModal from '../../../../common/SnippetModal/container';
import styles from './relatedAdsModalStyles';
import messages from './relatedAdsModalMessages';

type Props = {
  isShow: boolean,
  relatedAds: Array<Object>,
  redirectUrl: string,
  onModalClose: Function,
};

export default function RelatedAdsModal({
  isShow,
  redirectUrl,
  relatedAds,
  onModalClose,
}: Props): React.Node {
  if (!isShow) {
    return null;
  }

  return (
    <div className="related-ads-modal">
      <div className="overlay" />
      <div className="modal">
        <p>
          <FormattedMessage {...messages.title} />
        </p>

        <p className="subtitle">
          <strong>
            {' '}
            <FormattedMessage {...messages.subtitle} />
          </strong>
        </p>

        <LinkButton url={redirectUrl} color="primary" target="_self">
          <FormattedMessage {...messages.buttonText} />
        </LinkButton>

        <div className="list">
          <span className="related-title">
            <FormattedMessage {...messages.relatedTitle} />
          </span>
          {relatedAds.map(relatedAd => (
            <SnippetModal key={relatedAd.id} ad={relatedAd} />
          ))}
        </div>

        <ButtonLink
          type="button"
          styleType="primary"
          onClick={onModalClose}
          title={<FormattedMessage {...messages.linkText} />}
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Serp/components/Modals/RelatedAdsModals/RelatedAdsModal.js